import styled from 'styled-components';

export const IconDisplay = styled.div`
  svg {
    path {
      fill: ${({ theme }) => theme.colors.discrete};
    }
  }
`;

export const ColorSquare = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  margin: 0.75rem;
  border-radius: 0.25rem;
  background: ${({ color }) => color};
  border: none;
  box-sizing: border-box;
  border: 2px solid transparent;
  position: relative;
`;

export const BoldSpan = styled.span`
  font-size: ${({ theme }) => theme.fontStyles.smallBoldFont.fontSize}px;
  font-weight: ${({ theme }) => theme.fontStyles.smallBoldFont.fontWeight};
`;
